// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"vL-z","categoryName":"wL-z","categoryNameSearchHeader":"xL-z","categoryContent":"yL-z","bottomAligned":"zL-z","image":"AL-z","imageNoBackground":"BL-z"};